<template>
    <div class="box">
        <div class="head">
            <div style="width: 1220px;margin: 0 auto;">
                <div class="headBox">

                    <div class="headLeft">
                        <a href="https://ysb.emof.cn"> <img :src="user.morgwlogo ? user.morgwlogo : logo" alt=""></a>

                    </div>

                    <div class="headRight">
                        <div class='headRightTel flex align-center'>
                            <!--<el-dropdown @command="handleCommand" class="activeClass">-->
                            <!--&lt;!&ndash;<span class="">&ndash;&gt;-->
                            <!--&lt;!&ndash;{{nikName}}&ndash;&gt;-->
                            <!--<span class="jgsz" :class="{act:isAct === 8}">机构设置</span>-->
                            <!--&lt;!&ndash;<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>&ndash;&gt;-->
                            <!--&lt;!&ndash;</span>&ndash;&gt;-->
                            <!--<el-dropdown-menu slot="dropdown">-->
                            <!--<el-dropdown-item class="dc" command="/home/zhszBanKuai/jbxxBanKuai">基本信息</el-dropdown-item>-->
                            <!--<el-dropdown-item class="dc" command="/home/zhszBanKuai/zhaqBanKuai">账号安全</el-dropdown-item>-->
                            <!--</el-dropdown-menu>-->
                            <!--</el-dropdown>-->
                            <a :href="home" class="jgsz margin-right-xs" target="_blank">机构设置</a>

                            <span class="xxzx margin-right-xs" :class="{act:isAct === 9}" @click="toModular('/home/xxzxBanKuai')">消息中心</span>

                            <span class="guanb margin-right-xs" @click="singOut">退出</span>

                            <a :href="code" target="_blank" style="height: 40px;"><img src="../../assets/images/anniu.png"
                                                                                       style="height: 40px;width: auto;" alt=""></a>

                        </div>
                        <div class="headRightLogin">
                            <!--<div class="headRightDl">-->
                            <!--<img class="headIcon" :src="touXiang" alt="">-->
                            <!--<el-dropdown @command="handleCommand" class="activeClass">-->
                            <!--<span class="">-->
                            <!--&lt;!&ndash;{{nikName}}&ndash;&gt;-->
                            <!--<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                            <!--</span>-->
                            <!--<el-dropdown-menu slot="dropdown">-->
                            <!--<el-dropdown-item class="dc" command="/home/zhszBanKuai/jbxxBanKuai">基本信息</el-dropdown-item>-->
                            <!--<el-dropdown-item class="dc" command="/home/zhszBanKuai/zhaqBanKuai">账号安全</el-dropdown-item>-->
                            <!--</el-dropdown-menu>-->
                            <!--</el-dropdown>-->
                            <!--</div>-->
                            <!--<span style="margin-top: 5px;color: #ffffff;">{{nikName}}</span>-->

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="width: 1220px;margin: 0 auto;">
            <div class="tabBox">
                <div v-show="isAct === 3"></div>
                <div class="tabTex" v-show="isAct !== 3">{{ tabTex }}</div>
                <div class="headCenter" v-if="isAct !== 1">
                    <span class="headCenterTitle" :class="{act:isAct === 1}" @click="toModular('/home/syBanKuai')">首页</span>
                    <span class="headCenterTitle" :class="{act:isAct === 2}" @click="toModular('/home/mbzxBanKuai')">选择模板</span>
                    <span class="headCenterTitle" :class="{act:isAct === 3}" @click="toModular('/home/zncgBanKuai')">编辑内容</span>
                    <span class="headCenterTitle" :class="{act:isAct === 4}" @click="toModular('/home/zxwzBanKuai')">最新文章</span>
                    <!--<span class="headCenterTitle" :class="{act:isAct === 5}">导入文章</span>-->
                    <span class="headCenterTitle" :class="{act:isAct === 6}" @click="toModular('/home/wdwzBanKuai')">导出文章</span>
                    <span class="headCenterTitle" :class="{act:isAct === 7}" @click="toModular('/home/hszBanKuai')">回收站</span>
                    <span class="headCenterTitle" :class="{act:isAct === 10}" @click="toModular('/home/feedback')">意见反馈</span>
                    <!--<span class="headCenterTitle" :class="{act:isAct === 8}" @click="toModular('/home/bzzxBanKuai')">帮助中心</span>-->
                </div>
            </div>
        </div>
        <div class="info" :class="{bottom:isAct === 3}">
            <div class="cenBox">
                <router-view @setIsAct="setIsAct"/>
            </div>
        </div>
        <div class="footer" v-if="isAct !== 3">
            Copyright 益魔方
            <a href="https://beian.miit.gov.cn/" target="_blank" style="color: rgb(255, 255, 255);">京ICP备15038897号-3</a>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802038214" target="_blank" class="margin-lr-xs"
               style="color: rgb(255, 255, 255);">
                <img src="http://www.beian.gov.cn/img/new/gongan.png" alt="" style="vertical-align: text-top;">京公网安备11010802038214号</a>
            北京易魔方科技集团有限公司 版权所有
        </div>
    </div>
</template>

<script>
export default {
    name: "home",
    data() {
        return {
            logo: require('@/assets/images/logo.png'),
            isAct: '',
            dropActive: false,
            touXiang: '',
            code: '',
            home: '',
            url: 'https://www.emof.cn/vw/tiaoz?code=',
            tabTex: ''
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }

    },
    created() {
        if (!this.user) {
            this.$router.push("/login")
        }
        this.touXiang = this.user.mthumb
        this.nikName = this.user.mnickname
        this.code = (this.url + this.user.emofUserTokenSafer) + '&path=/home'
        this.home = (this.url + this.user.emofUserTokenSafer) + '&path=/st/setup'
    },
    methods: {
        singOut() {
            // this.$confirm('是否退出登录?', '提示', {
            //   confirmButtonText: '确定',
            //   cancelButtonText: '取消',
            //   type: 'warning'
            // }).then(() => {
            this.$store.state.user = null
            this.$store.state.cookie_user = null
            this.$store.state.emofUserTokenSafer = null
            this.$router.push('/login')
            this.$message({
                type: 'success',
                message: '退出成功'
            })
            // }).catch(() => {
            // })
        },
        toModular(path) {
            this.$router.push(path)
        },
        //
        handleCommand(command) {
            this.$router.push(command);
        },
        //
        setIsAct(isAct) {
            this.isAct = isAct
            if (1 === Number(isAct)) {
                this.tabTex = '当前位置：益书宝 > 首页'
            }
            if (2 === Number(isAct)) {
                this.tabTex = '当前位置：益书宝 > 选择模板'
            }
            if (3 === Number(isAct)) {
                this.tabTex = '当前位置：益书宝 > 编辑内容'
            }
            if (4 === Number(isAct)) {
                this.tabTex = '当前位置：益书宝 > 最新文章'
            }
            if (6 === Number(isAct)) {
                this.tabTex = '当前位置：益书宝 > 导出文章'
            }
            if (7 === Number(isAct)) {
                this.tabTex = '当前位置：益书宝 > 回收站'
            }
            if (10 === Number(isAct)) {
                this.tabTex = '当前位置：益书宝 > 意见反馈'
            }
        },
        handleVisible(v) {
            this.dropActive = v;//true or false
        }
    },
    watch: {}
}
</script>

<style scoped lang="scss">
.activeClass {
    font-size: 16px;
    color: #ffffff;
    cursor: pointer;
}

.act {
    background-image: linear-gradient(37deg,
        #ffb400 0%,
        #fc7802 100%),
    linear-gradient(
            #0a2240,
            #0a2240);
    background-blend-mode: normal,
    normal;
    border-radius: 18px;
    color: #fff !important;
    border: 0 !important;
}

.bottom {
    bottom: 0px !important;
}

.fix {
    position: fixed !important;
    left: 250px !important;
    right: 0 !important;
    bottom: 0 !important;
    z-index: 10 !important;
}

.fix2 {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    /*z-index: 10;*/
}

.guanb {
    display: block;
    width: 70px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background-color: #ff9600;
    border-radius: 20px;
    color: #fff;
}

.box {
    width: 100%;
    height: 100%;

    .head {
        width: 100%;
        height: 80px;
        background-color: #0a2240;
        box-shadow: 0px 6px 18px 1px rgba(10, 34, 64, 0.45);
        border-bottom: 2px solid #C9C5C5;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .headBox {
            min-width: 1220px;
            width: 100%;
            margin: 0 auto;
            height: 70px;
            display: flex;
            justify-content: space-between;

            .headLeft {
                /*width: 90px;*/
                height: 70px;
                line-height: 70px;
                margin-left: -10px;

                img {
                    //width: 520px;
                    height: 50px;
                    margin-top: 10px;
                }
            }


            .headRight {
                display: flex;
                justify-content: space-between;

                .headRightTel {
                    font-size: 16px;
                    height: 70px;
                    color: #ffffff;
                    line-height: 30px;
                    background-size: 16px 16px;

                    .shux {
                        margin: 0 10px;
                    }

                    .xxzx {
                        display: block;
                        width: 99px;
                        height: 40px;
                        text-align: center;
                        line-height: 38px;
                        border-radius: 20px;
                        border: solid 1px #ffffff;
                        cursor: pointer;
                        color: #fff;
                    }

                    .jgsz {
                        display: block;
                        width: 99px;
                        height: 40px;
                        text-align: center;
                        line-height: 38px;
                        border-radius: 20px;
                        border: solid 1px #ffffff;
                        cursor: pointer;
                        color: #fff;
                    }

                }

                .headRightLogin {
                    display: flex;
                    justify-content: space-between;
                    height: 40px;
                    margin: 20px;

                    div {
                        height: 30px;
                        line-height: 30px;
                        font-size: 16px;
                        color: #ffffff;
                        margin-left: 3px;
                    }

                    .headRightDl {
                        height: 30px;
                        line-height: 30px;
                        font-size: 16px;
                        color: #ffffff;
                        margin: 0 5px;

                        .headIcon {
                            width: 30px;
                            height: 30px;
                            border-radius: 15px;
                            vertical-align: middle;
                            margin-right: 5px;

                        }
                    }

                    .headRightZc {
                        width: 137px;
                        height: 38px;
                        background-color: #ffffff;
                        border-radius: 19px;
                        text-align: center;
                        line-height: 38px;
                        color: #0089ff;
                        font-size: 16px;
                        margin-left: 10px;
                    }
                }
            }
        }
    }

    .tabBox {
        width: 100%;
        height: 80px;
        display: flex;
        margin-left: -8px;
        justify-content: space-between;

        .tabTex {
            font-size: 16px;
            color: #999999;
            line-height: 80px;
        }

        .headCenter {
            height: 80px;
            padding: 20px 0;
            display: flex;
            justify-content: space-between;
            /*margin-left: 80px;*/
            span {
                display: block;
                padding: 0 15px;
                text-align: center;
                min-width: 100px;
                height: 40px;
                font-size: 16px;
                line-height: 40px;
                color: #0a2240;
                cursor: pointer;
                background-color: #fff;
                border: 1px solid #0a2240;
                margin: 0 10px;
                border-radius: 20px;
            }
        }

    }

    .info {
        width: 102%;
        padding-right: 2%;
        /*height: 100%;*/
        position: fixed;
        top: 150px;
        bottom: 50px;
        overflow-y: scroll;

        .cenBox {
            width: 100%;
            height: 100%;
        }
    }

    .footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 50px;
        z-index: 100;
        background: #0a2240;
        background-size: 100% 100%;
        line-height: 50px;
        font-size: 14px;
        color: #fff;
        text-align: center;
        /*margin-top: 100px;*/
    }

    .footer4 {
        position: fixed;
        bottom: 0;
        width: 100%;
        z-index: 1000;
        height: 50px;
        background-color: #f8f8f8;
        line-height: 50px;
        font-size: 14px;
        color: #666;
        text-align: center;
        /*margin-top: 100px;*/
    }
}
</style>
